class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header');

    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.content = this.details.querySelector('summary + *');

    this.addMenuEventListeners();    
  }

  addMenuEventListeners() {
    // Desktop Events
    if(window.innerWidth >= 750) {
      this.details.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.details.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      this.details.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    // Mobile Events
    if(window.innerWidth < 750) {
      document.addEventListener('click', this.onDocumentClick.bind(this));

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }  

  onSummaryClick(event) {
    this.content.style.display = "none";

    setTimeout(() => {
      this.content.style.display = "block";
    }, 10);
  }

  onMouseEnter(event) {
    if(this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }

    if (!this.details.hasAttribute('open')) {
      this.content.style.display = "none";

      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
      
      setTimeout(() => {
        this.content.style.display = "block";
      }, 10);      
    }
  }

  onMouseLeave(event) {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
  }

  onFocusOut(event) {    
    setTimeout(() => {
      const relatedTarget = event.relatedTarget;
      
      if (!relatedTarget || !this.details.contains(relatedTarget)) {
        this.close();
      }
    }, 0);
  }

  onDocumentClick(event) {
    if (!this.details.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define('header-menu', HeaderMenu);
